import axios from 'lib/axios'

export const followUpApi = async (processId: number, path: string, body?: unknown) => {
  const url = `/follow-up/process/${processId}/${path}`
  const response = body === undefined ? await axios.get(url) : await axios.post(url, body)
  return response.data.data
}

export const downloadFollowUp = async (processId: number, path: string, filename: string, body: unknown = {}) => {
  const response = await axios.post(`/follow-up/process/${processId}/${path}`, body, { responseType: 'blob' })
  const url = URL.createObjectURL(response.data)
  const link = document.createElement('a')
  link.href = url
  link.download = filename
  link.click()
  URL.revokeObjectURL(url)
}
